import type { CSSProperties, HTMLAttributes } from "react";
import { cx } from "./cx";
import "./Skeleton.css";

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: "text" | "rect" | "circle";
  /** CSS length, e.g. "60%" or "var(--space-8)". */
  width?: string;
  height?: string;
  /** Number of text lines; the last one is shorter. */
  lines?: number;
}

/** Placeholder shimmer matching the final layout. Hidden from assistive tech. */
export function Skeleton({
  variant = "text",
  width,
  height,
  lines = 1,
  className,
  style,
  ...rest
}: SkeletonProps) {
  const sized: CSSProperties = { width, height, ...style };
  if (variant === "text" && lines > 1) {
    return (
      <span className={cx("ui-skeleton-lines", className)} aria-hidden="true" {...rest}>
        {Array.from({ length: lines }, (_, i) => (
          <span
            key={i}
            className="ui-skeleton ui-skeleton--text"
            style={i === lines - 1 ? { width: "60%" } : sized}
          />
        ))}
      </span>
    );
  }
  return (
    <span
      className={cx("ui-skeleton", `ui-skeleton--${variant}`, className)}
      style={sized}
      aria-hidden="true"
      {...rest}
    />
  );
}
